import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorChangePriceComponent } from './error-change-price.component';



@NgModule({
  declarations: [
    ErrorChangePriceComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    ErrorChangePriceComponent
  ]
})
export class ErrorChangePriceModule { }
